export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/a92d826d80900dda6092d3b109ffaee1.svg";